export default __webpack_public_path__ + "static/media/black-warning-icon.f4379d02.svg";